// extracted by mini-css-extract-plugin
module.exports = {"feedCard":"FeedCard_feedCard__g7W7t"};